export default __webpack_public_path__ + "static/media/cover4.f106a4d6.jpg";